import RestApiModel from "@/api/Model/RestApiModel";

class SubmitRater extends RestApiModel {
  static getResourceEndpoint() {
    return '/SubmitRater';
  }
}

export default SubmitRater;
